import { Project } from '../types';

export const projects: Project[] = [
	{
		title: 'Travel Advisor',
		icon: 'icon-map',
		description:
			'AI-powered travel itinerary generator that streams personalised multi-day guides via Claude Haiku. Enter a destination and trip duration and the app delivers structured itineraries with landmarks, restaurants, and tips, then auto-links attractions to Viator and Google Maps. Implements prompt caching for ≈90% cost reduction on repeat calls, cookie-based rate limiting, and PDF/PNG export.',
		tags: ['Next.js 15', 'TypeScript', 'Anthropic API', 'Claude Haiku', 'Streaming', 'Tailwind CSS', 'Vercel'],
		url: 'https://traveladvisor.pmagas.com',
	},
	{
		title: 'NewsHub',
		icon: 'icon-newspaper',
		description:
			'News aggregation platform that scrapes headlines from 36 global sources and uses Claude Sonnet to generate article summaries and personalised topic recommendations based on browsing history. Features JWT authentication, MongoDB Atlas, drag-and-drop feed customisation, and optional Perplexity API fallback for summarisation.',
		tags: ['Next.js 15', 'TypeScript', 'Anthropic API', 'Claude Sonnet', 'Express.js', 'MongoDB', 'Docker', 'Playwright'],
		url: 'https://newshub.pmagas.com',
	},
];
